export default {
  'cloak.ipacl.col.ip': 'IP/Range',
  'cloak.ipacl.col.type': 'Type',
  'cloak.ipacl.col.status': 'Status',
  'cloak.ipacl.col.remark': 'Remark',
  'cloak.ipacl.col.action': 'Action',
  'cloak.ipacl.whitelist': 'Whitelist',
  'cloak.ipacl.blacklist': 'Blacklist',
  'cloak.ipacl.add': 'Add',
  'cloak.ipacl.edit': 'Edit',
  'cloak.ipacl.delete': 'Delete',
  'cloak.ipacl.deleteConfirm': 'Confirm delete?',
  'cloak.ipacl.modal.edit': 'Edit IP Rule',
  'cloak.ipacl.modal.add': 'Add IP Rule',
  'cloak.ipacl.form.ipType': 'IP Type',
  'cloak.ipacl.form.filterType': 'Filter Type',
  'cloak.ipacl.form.singleIp': 'Single IP',
  'cloak.ipacl.form.singleIpExtra': 'Enter a single IP, e.g. 192.168.1.1',
  'cloak.ipacl.form.singleIpPlaceholder': 'Single IP (or use range)',
  'cloak.ipacl.form.ipStart': 'Range Start',
  'cloak.ipacl.form.ipStartExtra': 'Enter range start address',
  'cloak.ipacl.form.ipStartPlaceholder': 'Range start (or use single IP)',
  'cloak.ipacl.form.ipEnd': 'Range End',
  'cloak.ipacl.form.ipEndExtra': 'Enter range end address',
  'cloak.ipacl.form.ipEndPlaceholder': 'Range end',
  'cloak.ipacl.form.remark': 'Remark',
  'cloak.ipacl.form.remarkPlaceholder': 'Remark description',
  'cloak.ipacl.form.cidr': 'CIDR',
  'cloak.ipacl.form.cidrExtra':
    'Enter CIDR, e.g. 192.168.1.0/24 (auto-expand to range)',
  'cloak.ipacl.form.cidrPlaceholder': 'CIDR (choose one with single IP/range)',
  'cloak.ipacl.statusPlaceholder': 'Status',
  'cloak.ipacl.msg.deleteOk': 'Deleted',
  'cloak.ipacl.msg.deleteErr': 'Delete failed',
  'cloak.ipacl.msg.updateOk': 'Updated',
  'cloak.ipacl.msg.updateErr': 'Update failed',
  'cloak.ipacl.msg.addOk': 'Added',
  'cloak.ipacl.msg.addErr': 'Add failed',
  'cloak.ipacl.import': 'Import',
  'cloak.ipacl.import.title': 'Batch Import IP Rules',
  'cloak.ipacl.import.upload': 'Drag txt file here, or click to select',
  'cloak.ipacl.import.format':
    'One per line, supports CIDR/single IP/range(use -)',
  'cloak.ipacl.import.selected': 'Selected',
  'cloak.ipacl.import.reselect': 'Reselect',
  'cloak.ipacl.import.preview': 'Preview',
  'cloak.ipacl.import.valid': 'Valid',
  'cloak.ipacl.import.invalid': 'Invalid',
  'cloak.ipacl.import.formatError': 'Format error',
  'cloak.ipacl.import.dupSkip': 'Duplicate skipped',
  'cloak.ipacl.import.success': 'Successfully imported {count}',
  'cloak.ipacl.import.fail': 'Import failed',
  'cloak.ipacl.import.overLimit': 'Exceeds limit of {limit}',
  'cloak.ipacl.import.empty': 'File is empty or has no valid lines',
  'cloak.geo.title': 'Geo Rules',
  'cloak.advanced.title': 'ASN Advanced Rules',
};
